"use client";

import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import Image from "next/image";
import Link from "next/link";
import { memo } from "react";
import { useCasesHeroData } from "./constants";
import { UseCasesHeroProps } from "./types";

const UseCasesHero = ({
  className,
}: UseCasesHeroProps) => {
  const {
    title,
    description,
    primaryButton,
    secondaryButton,
    imageUrl,
    imageDimensions,
  } = useCasesHeroData;
  return (
    <section
      className={cn(
        "overflow-hidden section pt-[var(--main-header-height,56px)] lg:pt-[var(--main-header-height,54px)] bg-background-hero",
        className
      )}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 pt-6 pb-6 gap-8 md:pt-30 lg:text-start lg:grid-cols-[9fr_11fr] lg:gap-[22px] lg:py-20">
          <div className="flex flex-col lg:justify-center gap-8 lg:max-w-[496px]">
            <div className="grid grid-cols-1 gap-2 md:gap-8">
              <Typography variant="headingMain" className="w-full">
                <h1>{title}</h1>
              </Typography>
              <Typography variant="bodyLg" asChild>
                <p>{description}</p>
              </Typography>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:flex flex-wrap lg:gap-2.5">
              {!!primaryButton && (
                <Button
                  asChild
                  variant="primary"
                  className="sm:w-[247px] h-[48px]"
                >
                  <Link href={primaryButton.href} className="!text-base w-full">
                    {primaryButton.label}
                  </Link>
                </Button>
              )}
              {!!secondaryButton && (
                <Button
                  asChild
                  variant="primary-outline"
                  className="h-[48px] sm:w-[141px]"
                >
                  <Link
                    href={secondaryButton?.href}
                    className="!text-base w-full"
                  >
                    {secondaryButton?.label}
                  </Link>
                </Button>
              )}
            </div>
          </div>
          {imageUrl && (
            <div className="flex items-start">
              <Image
                alt="Languex Illustration"
                src={imageUrl}
                width={imageDimensions?.width}
                height={imageDimensions?.height}
                className="flex-auto min-w-0"
                quality={100}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(UseCasesHero);
